import { render, staticRenderFns } from "./MyApproval.vue?vue&type=template&id=2210aff0&scoped=true"
import script from "./MyApproval.vue?vue&type=script&lang=js"
export * from "./MyApproval.vue?vue&type=script&lang=js"
import style0 from "./MyApproval.vue?vue&type=style&index=0&id=2210aff0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2210aff0",
  null
  
)

export default component.exports